/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TelegramLinkResponse
 */
export interface TelegramLinkResponse {
    /**
     * The generated Telegram deep link (t.me/YourBot?start=TOKEN)
     * @type {string}
     * @memberof TelegramLinkResponse
     */
    link: string;
}

/**
 * Check if a given object implements the TelegramLinkResponse interface.
 */
export function instanceOfTelegramLinkResponse(value: object): value is TelegramLinkResponse {
    if (!('link' in value) || value['link'] === undefined) return false;
    return true;
}

export function TelegramLinkResponseFromJSON(json: any): TelegramLinkResponse {
    return TelegramLinkResponseFromJSONTyped(json, false);
}

export function TelegramLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TelegramLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'link': json['link'],
    };
}

export function TelegramLinkResponseToJSON(json: any): TelegramLinkResponse {
    return TelegramLinkResponseToJSONTyped(json, false);
}

export function TelegramLinkResponseToJSONTyped(value?: TelegramLinkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'link': value['link'],
    };
}

